import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import store from '../store';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken, removeToken } from '@/utils/token';
import { renderRoutes, renderMenu, renderAuthRoute } from '@/utils/common';

const routes = [
    {
        path: '/login',
        name: '登录页',
        component: () => import('../views/login/index.vue'),
        children: []
    },
    {
        path: '',
        redirect: '/home'
    },
    {
        path: '/home',
        component: () => import('../layout/MainLayout.vue'),
        children: [
            {
                path: '',
                name: '首页',
                meta: { keep: 'keep-dashborad', isCache: true, isCreate: true, name: '首页' },
                component: () => import('../views/home/index.vue')
            }
        ]
    },
    {
        path: '/:pathMatch(.*)*',
        component: () => import('@/views/error/404'),
        children: []
    }
];
let isHash = true;
const router = createRouter({
    history: isHash ? createWebHashHistory() : createWebHistory(),
    routes
});

const componentTypeList = [
    'cus_state',
    'deal_state',
    'cus_cooperation',
    'cus_category',
    'data_authority',
    'employee_duty',
    'employee_role',
    'cus_level',
    'cus_grade',
    'dict_type',
    'cus_type',
    'maintain_type',
    'visit_type',
    'visit_purpose',
    'plan_origin',
    'visit_effective',
    'visit_plan_archive',
    'cus_importance',
    'exp_group',
    'score_type',
    'control_type',
    'business_type',
    'sign_way',
    'income_type',
    'income_forecast_type',
    'operation_state',
    'operation_type',
    'medical_item_type_code',
    'examine_type_code',
    'examine_way_code',
    'examine_group_code',
    'disease_type_code',
    'special_type_code_1',
    'special_type_code_2',
    'employee_attitude',
    'contract_type',
    'renew',
    'keyman_type',
    'archive_full_type',
    'cus_prop',
    'customer_asset_type',
    'income_target_type',
    'data_authority_high',
    // 'data_authority_4_high',
    'exp_type_code',
    'customer_credit_archive_ext_type',
    'professional_title',
    'income_target_customer_unusual_type',
    'board_customer_field',
    'customer_state_simple',
    'action_plan_finish_code',
    'administrative_level_code',
    'expense_type_code',
    'effect_type_code',
    'issue_solve_state',
    'action_plan_state_code',
    'action_plan_type_code',
    'action_plan_period_code',
    'action_plan_important_code',
    'important_code',
    'post_type_code',
    'indicator_type_code',
    'keypoint_period_code',
    'keypoint_state_code',
    'keypoint_important_code',
    'indicator_business_type_code',
    'keypoint_template_type_code',
    'customer_develop_archive',
    'returned_actual_type',
    'affiliation_code',
    'expense_reimburse_archive',
    'difficult_reason_type_code',
    'expense_standard_customer_month_archive',
    'responsible_party',
    'return_period_type',
    'return_matter_reason_type',
    'return_matter_attention_code',
    'return_case_stage',
    'return_account_total_proportion_cus_prop',
    'cus_opp_opportunity_stage',
    'cus_opp_sale_stage',
    'field_integrity_table',
    'cooperation_model_code'
];

let configItem = [''];

NProgress.configure({ showSpinner: false });

router.beforeEach(async (to, from, next) => {
    NProgress.start();
    if (getToken()) {
        if (to.path == '/login') {
            next({ path: '/' });
        } else {
            if (!store.state.common.isLogin) {
                try {
                    let res = await store.dispatch('getUserInfo');
                    if (res?.code == 200) {
                        const { catalogueMenuList, buttonCodeList } = res.data;
                        let assetRoute = store.state.app.routers;
                        let permissionList = [];
                        let authRoutes = [
                            // {
                            //     path: '/home',
                            //     menuName: '首页'
                            // }
                        ];
                        if (catalogueMenuList) {
                            let _catalogueMenuList = catalogueMenuList.filter(item => item.path != '/home');
                            authRoutes.push(..._catalogueMenuList);
                        }

                        if (buttonCodeList) {
                            permissionList = [...buttonCodeList];
                        }
                        let menuAll = store.state.app.menuAll;
                        let menuRoutes = renderMenu(
                            [
                                {
                                    path: '/home',
                                    menuName: '首页'
                                },
                                ...authRoutes
                            ],
                            menuAll
                        );
                        const ml = [...menuRoutes];

                        let menuList = _.cloneDeep(authRoutes);
                        let authRouters = _.cloneDeep(assetRoute);
                        //renderRoutes(assetRoute, authRoutes, permissionList, router);
                        const mls = renderAuthRoute(menuList, authRouters, permissionList, '');
                        mls.map(item => router.addRoute(item));
                        store.dispatch('reloadMenu', ml);
                        store.dispatch('setPermission', permissionList);
                        store.dispatch('loginSuc', true);

                        // store.dispatch('SET_AGENT_FLAG', true);

                        // await store.dispatch('QUERY_CONFIG_ITEM', configItem);
                        store.dispatch('getMenuTree');
                        store.dispatch('QUERY_SERVE_DATE');
                        store.dispatch('QUERY_FLOWABLE_STATE');
                        await store.dispatch('QUERY_AGENT_LIST');
                        await store.dispatch('QUERY_AGENT_FLOWABLE', {});
                        await store.dispatch('DictList', {
                            typeCodeList: componentTypeList
                        });

                        next({
                            ...to,
                            replace: true
                        });
                    } else {
                        removeToken();
                        next('/login');
                    }
                } catch (error) {}
            } else {
                next();
            }
        }
    } else {
        if (to.path == '/login') {
            next();
        } else {
            next('/login');
        }
    }
});

router.afterEach(() => {
    NProgress.done();
});

export default router;
